/**
 * Admin-mode configuration.
 *
 * INTERIM (pre-launch) admin UI for curating the public Assets library.
 * All values here are NON-SECRET — clientId/tenantId/siteId are public per
 * Microsoft's threat model for MSAL public-client SPAs. The only thing
 * keeping bad actors out is the IP firewall on mktgassets.moldex.com.
 *
 * REVERT BEFORE LAUNCH (July 2026): see docs/ADMIN_MODE.md.
 */

export const ADMIN_CONFIG = {
  // Entra "Moldex DAM Admin" app (3164486b-...). MUST have a SPA platform
  // registered with redirect URIs for https://mktgassets.moldex.com and
  // http://localhost:5173, plus delegated Sites.ReadWrite.All.
  tenantId: "ffd3dfdc-42b0-4f78-bc24-878957940318",
  clientId: "3164486b-c9d3-4f33-aa50-6cab2861ffe6",

  // Public content lives on the shared marketing site. PRIVATE (removed/internal)
  // assets now live on a DEDICATED, isolated site so the CDN worker's app-only
  // credential can be scoped (Sites.Selected) to the public site only and is
  // incapable of reading internal content. Disposition below runs as the signed-in
  // admin USER (delegated Sites.ReadWrite.All), who has access to both sites.
  siteId: "moldex.sharepoint.com,f9302455-350b-47fd-9077-a196274b81b2,965cb721-9a09-46f7-bab4-7e668afeb2a1",
  privateSiteId: "moldex.sharepoint.com,fce9badb-5c06-4d15-b1ff-c28d29f57ec5,12d1f2df-19b8-4a04-a9c1-32985f4e0a6d",
  publicLibrary: "Assets",
  privateLibrary: "InternalAssets",

  // Where the picker stores its hide-from-public list. Fetched same-origin via
  // the Cloudways /cdn/ proxy so the SP Public CDN Referer requirement is met.
  blocklistFilename: "blocklist.json",

  // Graph permission scope requested at sign-in.
  scopes: ["Sites.ReadWrite.All"],

  // Entra App Role required to USE admin mode (in addition to SharePoint
  // permissions). Signing in without this role shows a "no permission"
  // notice instead of the admin UI. Role assignments are managed in Entra
  // (Enterprise Applications → Moldex DAM Admin → Users and groups), so
  // adding/removing curators doesn't require a redeploy.
  adminRole: "DamAdmin",
} as const;
